import { render, staticRenderFns } from "./AboutContent.vue?vue&type=template&id=e8f7f786&scoped=true"
import script from "./AboutContent.vue?vue&type=script&lang=js"
export * from "./AboutContent.vue?vue&type=script&lang=js"
import style0 from "./AboutContent.vue?vue&type=style&index=0&id=e8f7f786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f7f786",
  null
  
)

export default component.exports